export default __webpack_public_path__ + "static/modernux-72019c933e5da4f45ad120b44d4ec360.mp4";